var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-template"},[_c('Header',{attrs:{"showInput":false}}),_c('Dash-body',{staticStyle:{"min-height":"100vh"}}),(_vm.getSelectedPages.length > 1)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }